/* Tailor & Tails — product page behaviour.
   Each init function is safe to run repeatedly (theme editor reloads sections). */
(function () {
  'use strict';

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (root.dataset.ttReady) return;
    root.dataset.ttReady = '1';
    var slides = root.querySelectorAll('[data-tt-slide]');
    var thumbs = root.querySelectorAll('[data-tt-thumb]');
    var current = 0;

    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        if (n === current) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.dataset.ttThumb)); });
    });
    var prev = root.querySelector('[data-tt-prev]');
    var next = root.querySelector('[data-tt-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    // Swipe on touch screens
    var startX = null;
    var main = root.querySelector('.tt-gallery__main');
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(pdp) {
    if (pdp.dataset.ttReady) return;
    pdp.dataset.ttReady = '1';

    var tiersWrap = pdp.querySelector('[data-tt-tiers]');
    var tiers = Array.prototype.slice.call(pdp.querySelectorAll('[data-tt-tier]'));
    var petButtons = pdp.querySelectorAll('[data-tt-pets]');
    var purchaseButtons = pdp.querySelectorAll('[data-tt-purchase]');
    var planInput = pdp.querySelector('[data-tt-plan-input]');
    var shipping = pdp.querySelector('[data-tt-shipping]');
    var shippingText = pdp.querySelector('[data-tt-shipping-text]');
    var atc = pdp.querySelector('[data-tt-atc]');
    var atcText = pdp.querySelector('[data-tt-atc-text]');

    function mode() {
      return tiersWrap ? tiersWrap.dataset.mode : 'once';
    }

    function selectedIndex() {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].querySelector('input').checked) return i;
      }
      return 0;
    }

    function refreshPrices() {
      var m = mode();
      tiers.forEach(function (tier) {
        var each = tier.querySelector('[data-tt-each]');
        var total = tier.querySelector('[data-tt-total]');
        if (each) each.textContent = m === 'subscribe' ? tier.dataset.priceSub : tier.dataset.priceOnce;
        if (total) total.textContent = m === 'subscribe' ? tier.dataset.totalSub : tier.dataset.totalOnce;
      });
    }

    function refreshSelection() {
      var idx = selectedIndex();
      tiers.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      petButtons.forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.ttPets) === idx); });

      var selectedTier = tiers[idx];
      var quantity = selectedTier ? Number(selectedTier.querySelector('input').value) : 1;
      var unlockQuantity = shipping ? Number(shipping.dataset.unlockQuantity) : 2;
      if (shipping) shipping.classList.toggle('is-unlocked', quantity >= unlockQuantity);
      if (shippingText) shippingText.textContent = quantity >= unlockQuantity ? 'Free shipping unlocked' : 'Free shipping with 2+ jars';

      // Sold-out state
      var tier = tiers[idx];
      if (atc && tier) {
        var available = tier.dataset.available === 'true';
        atc.disabled = !available;
        if (atcText) atcText.textContent = available ? atc.dataset.label : 'Sold out';
      }
    }

    tiers.forEach(function (tier) {
      tier.querySelector('input').addEventListener('change', refreshSelection);
    });

    petButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tier = tiers[Number(btn.dataset.ttPets)];
        if (!tier) return;
        var input = tier.querySelector('input');
        if (input.disabled) return;
        input.checked = true;
        refreshSelection();
      });
    });

    purchaseButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = btn.dataset.ttPurchase;
        purchaseButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (tiersWrap) tiersWrap.dataset.mode = m;
        if (planInput) planInput.disabled = m !== 'subscribe';
        refreshPrices();
      });
    });

    refreshPrices();
    refreshSelection();
    initDelivery(pdp);
    initSticky(pdp);
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) days--;
    }
    return d;
  }

  function initDelivery(pdp) {
    var el = pdp.querySelector('[data-tt-delivery]');
    if (!el) return;
    var min = Number(pdp.dataset.deliveryMin) || 3;
    var max = Number(pdp.dataset.deliveryMax) || 7;
    var fmt = { month: 'short', day: 'numeric' };
    var today = new Date();
    try {
      el.textContent =
        addBusinessDays(today, min).toLocaleDateString(undefined, fmt) +
        ' – ' +
        addBusinessDays(today, max).toLocaleDateString(undefined, fmt);
    } catch (e) { /* keep the server-rendered fallback text */ }
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initSticky(pdp) {
    var bar = pdp.querySelector('[data-tt-sticky]');
    var atc = pdp.querySelector('[data-tt-atc]');
    if (!bar || !atc) return;
    var stickyBtn = bar.querySelector('button');
    var shown = null;

    function update() {
      // Show once the main button has scrolled above the viewport
      var show = atc.getBoundingClientRect().bottom < 0;
      if (stickyBtn) stickyBtn.disabled = atc.disabled;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Before / after ---------- */
  function initBeforeAfter(root) {
    if (root.dataset.ttReady) return;
    root.dataset.ttReady = '1';
    var tabs = root.querySelectorAll('[data-tt-ba-tab]');
    var panes = root.querySelectorAll('[data-tt-ba-pane]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.ttBaTab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) { p.hidden = p.dataset.ttBaPane !== key; });
      });
    });

    root.querySelectorAll('[data-tt-ba-range]').forEach(function (range) {
      var frame = range.closest('.tt-ba__frame');
      function update() { frame.style.setProperty('--tt-ba', range.value + '%'); }
      range.addEventListener('input', update);
      update();
    });
  }

  /* ---------- Simple carousels (arrows scroll a snap track) ---------- */
  function initCarousel(root) {
    if (root.dataset.ttReady) return;
    root.dataset.ttReady = '1';
    var track = root.querySelector('[data-tt-track]');
    if (!track) return;
    function step(dir) {
      var card = track.firstElementChild;
      var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-tt-carousel-prev]');
    var next = root.querySelector('[data-tt-carousel-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Only one video plays at a time
    track.addEventListener('play', function (e) {
      track.querySelectorAll('video').forEach(function (v) { if (v !== e.target) v.pause(); });
    }, true);
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tt-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-tt-pdp]').forEach(initBuyBox);
    scope.querySelectorAll('[data-tt-ba]').forEach(initBeforeAfter);
    scope.querySelectorAll('[data-tt-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
